<template>
  <div class="page" v-wechat-title="$route.meta.title='找不到页面'">

    <div class="not-found">
      <img src="../../assets/error-bg.png" alt="">
      <p>当前页面已丢失</p>
    </div>


  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'


  export default {
    data(){
      return{
        res: {}
      }
    },
    computed: {

    },
    created() {

    },
    methods: {

    },
    components: {

    },

  }

</script>

<style scoped>

  .not-found{ padding-top: 30%; margin: 0 auto; text-align: center;  }
  .not-found img{ width: 60%; height: auto;  }
  .not-found p{margin-top:.2rem; font-size: .3rem; color: #999; line-height: .4rem;  }
</style>



// WEBPACK FOOTER //
// src/page/404/404.vue